import React from 'react';
export function BrandStatement() {
  return <section className="bg-cream py-24 md:py-32 px-6" data-id="element-36">
      <div className="max-w-4xl mx-auto text-center" data-id="element-37">
        <p className="font-serif font-light text-3xl md:text-4xl lg:text-5xl text-espresso leading-relaxed" data-id="element-38">
          Pure Pulse is movement made beautiful. Pieces designed to move with
          you, made to be lived in, on the mat and beyond.
        </p>
      </div>
    </section>;
}